import React, { useState, useCallback } from "../../__compat__/react/main.entry.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickComponentCommonProps, pickAriaProps, pickDataProps, } from "../../interfaces/commonProps.mjs.mjs";
import { FormHelperText } from "../FormHelperText/index.mjs.mjs";
import { FormLabel } from "../FormLabel/index.mjs.mjs";
import { StyledContainer, StyledToggleButton, StyledOnIndicator, StyledOffIndicator, StyledToggleContainer, StyledToggleSwitch, StyledLabelContainer, StyledFormLabelContainer, } from "./Toggle.styles.mjs.mjs";
export const Toggle = React.forwardRef(({ id, name, on, defaultOn = false, disabled = false, children, hint, inputId, inputRef, labelPosition = 'right', onChange: handleChange = () => { }, 'aria-labelledby': ariaLabelledBy, 'aria-label': ariaLabel, ...restProps }, ref) => {
    const [internalState, setInternalState] = useState(defaultOn);
    const state = on !== null && on !== void 0 ? on : internalState;
    const handleClick = useCallback((event) => {
        handleChange(!state, event);
        if (on === undefined) {
            setInternalState(!internalState);
        }
    }, [handleChange, internalState, on, state]);
    const generateLabelContent = () => {
        if (!children && !hint) {
            return;
        }
        return (React.createElement(StyledLabelContainer, { labelPosition: labelPosition },
            children && (React.createElement(StyledFormLabelContainer, null,
                React.createElement(FormLabel, { id: labelId, variant: "static", disabled: disabled, htmlFor: inputId, required: true }, children))),
            hint && (React.createElement(FormHelperText, { variant: "hint", disabled: disabled }, hint))));
    };
    const labelId = `${inputId}-label`;
    return (React.createElement(StyledContainer, { id: id, ref: ref, outerSpacing: useSpacing(restProps), ...pickComponentCommonProps(restProps), ...pickAriaProps(restProps), ...pickDataProps(restProps) },
        labelPosition === 'left' && generateLabelContent(),
        React.createElement(StyledToggleContainer, null,
            React.createElement(StyledToggleButton, { id: inputId, ref: inputRef, name: name, type: "button", role: "switch", disabled: disabled, "aria-labelledby": ariaLabelledBy || labelId, "aria-label": ariaLabel, "aria-checked": state, onClick: handleClick }),
            React.createElement(StyledOnIndicator, null),
            React.createElement(StyledOffIndicator, null),
            React.createElement(StyledToggleSwitch, null)),
        labelPosition === 'right' && generateLabelContent()));
});
Toggle.displayName = 'Toggle';
//# sourceMappingURL=Toggle.mjs.mjs.map